module.exports = __webpack_public_path__ + "img/degustationActive.d6f843aa.png";